import { render, staticRenderFns } from "./usercotation.vue?vue&type=template&id=6494fd76&scoped=true"
import script from "./usercotation.vue?vue&type=script&lang=js"
export * from "./usercotation.vue?vue&type=script&lang=js"
import style0 from "./usercotation.vue?vue&type=style&index=0&id=6494fd76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6494fd76",
  null
  
)

export default component.exports